import React from 'react';
import styles from './AlertBanner.module.scss';

interface AlertBannerProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
  type?: 'informative' | 'success' | 'warning' | 'error';
}

const AlertBanner: React.FC<AlertBannerProps> = ({
  message,
  isVisible,
  onClose,
  type = 'informative'
}) => {
  if (!isVisible) {
    return null;
  }
  return (
    <div className={`${styles.alertBanner} ${styles[type]}`}>
      {/* Icon */}
      <div className={styles.icon}>
        <div className={styles.iconFrame}>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1ZM9 5C9.41421 5 9.75 5.33579 9.75 5.75V9.25C9.75 9.66421 9.41421 10 9 10C8.58579 10 8.25 9.66421 8.25 9.25V5.75C8.25 5.33579 8.58579 5 9 5ZM9 11.5C8.58579 11.5 8.25 11.8358 8.25 12.25C8.25 12.6642 8.58579 13 9 13C9.41421 13 9.75 12.6642 9.75 12.25C9.75 11.8358 9.41421 11.5 9 11.5Z"
                fill="currentColor"
              />
            </g>
          </svg>
        </div>
      </div>

      {/* Content */}
      <div className={styles.content}>
        <div className={styles.text}>{message}</div>
      </div>

      {/* Button and Close */}
      <div className={styles.buttonAndClose}>
        <div className={styles.closeAndDivider}>
          {/* Divider */}
          <div className={styles.divider}>
            <svg
              width="1"
              height="32"
              viewBox="0 0 1 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="1" height="32" fill="rgba(255, 255, 255, 0.2)" />
            </svg>
          </div>

          {/* Close button */}
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close banner"
          >
            <div className={styles.closeIcon}>
              <svg
                width="8"
                height="8"
                viewBox="0 0 8 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.646447 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L4 3.29289L6.64645 0.646447C6.84171 0.451184 7.15829 0.451184 7.35355 0.646447C7.54882 0.841709 7.54882 1.15829 7.35355 1.35355L4.70711 4L7.35355 6.64645C7.54882 6.84171 7.54882 7.15829 7.35355 7.35355C7.15829 7.54882 6.84171 7.54882 6.64645 7.35355L4 4.70711L1.35355 7.35355C1.15829 7.54882 0.841709 7.54882 0.646447 7.35355C0.451184 7.15829 0.451184 6.84171 0.646447 6.64645L3.29289 4L0.646447 1.35355C0.451184 1.15829 0.451184 0.841709 0.646447 0.646447Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertBanner;
